export enum OrderWorkflow {
    PRODUCT_SELECTION = 0, //'productSelectionModule',
    PAYMENT_METHOD, // = 'paymentMethodModule',
    PAYMENT_INFORMATION // = 'paymentInformationModule',
}

export enum PaymentMethod {
    STRIPE = 'stripe',
    INVOICE = 'invoice',
    EXTERNAL = 'external',
    MANUAL = 'manual'
}

export type PaymentMethodDetails = StripePaymentMethodDetails | ExternalPaymentMethodDetails;

export interface StripePaymentMethodDetails {
    stripePaymentMethodId: string;
}

export interface ExternalPaymentMethodDetails {
    username: string;
    password: string;
}

// Type Guard
export const isStripePaymentMethodDetails = (
    details: PaymentMethodDetails
): details is StripePaymentMethodDetails => {
    return (details as StripePaymentMethodDetails).stripePaymentMethodId !== undefined;
};

// Type Guard
export const isExternalPaymentMethodDetails = (
    details: PaymentMethodDetails
): details is ExternalPaymentMethodDetails => {
    return (
        (details as ExternalPaymentMethodDetails).username !== undefined &&
        (details as ExternalPaymentMethodDetails).password !== undefined
    );
};
